(function() {

    function equalHeight() {
        var productWrapperHeight = document.getElementsByClassName('compare-product-wrapper')[0];
        var productHeight = Array.from(document.querySelectorAll('.product-info-content'));
        var sidebarHeight = document.getElementsByClassName('compare-product-sidebar')[0];
        var sidebarWhitespace = document.getElementById('compare-product__placeholder');
        var listContainer = document.getElementsByClassName('compare-product-table');
        var list = !!listContainer && !!listContainer.length && listContainer[0];
        var titles = Array.from(document.querySelectorAll('.product-info__title'));

        if (!!list) {
            checkHeight(titles);
            checkHeight(productHeight);

            if (productHeight.length > 0) {
                sidebarWhitespace.style.height = productHeight[0].offsetHeight + 'px';
            }

            sidebarHeight.style.height = productWrapperHeight.offsetHeight + 'px';

            var listItems = Array.from(list.querySelectorAll('.compare-product-attributes__value'));

            listItems.map(function(item) {
                var index = item.getAttribute('data-item');
                var rowItems = Array.from(document.querySelectorAll('[data-item="' + index + '"]'));

                checkHeight(rowItems);
            });
        }
    }

    function checkHeight(row) {
        var max = 0;

        row.map(function(item) {
            item.style.height = 'auto';
            var divHeight = item.offsetHeight;
            max = divHeight > max ? divHeight : max;
        });

        row.map(function(item) {
            item.style.height = max + 'px';
        });
    }

    equalHeight();

    window.addEventListener("resize", function(){
        equalHeight();
    });
})();


